export default {
  id: 70,
  title: 'Target #70 - Froggy',
  url: 'https://cssbattle.dev/play/70',
  colors: ['#293462', '#FE5F55', '#A64942', '#FFF1C1'],
  solution:
    '<a a><a b><a c><a d><style>[d],body{background:#293462}[b],[c],[d]{border-radius:50%}a{position:fixed}[a]{top:110;left:125;width:150;height:100;background:radial-gradient(ellipse 90% 77% at top,#fe5f55 90%,#a64942 91%);border-radius:60px}[b],[c]{width:50;height:50;background:#fff1c1;box-shadow:inset 0 0 0 10px #fe5f55}[b]{top:85;left:140}[c]{top:85;left:210}[d]{top:105;left:160;width:10;height:10;box-shadow:70px 0 #293462,25px 55px #293462,45px 55px #293462}</style>',
}
